<template>
	<div class="h-100" v-if="showLogin || showWaiting">
		<!--<div class="text-right" style="position: absolute; left: 0; right: 0; z-index: 9999">
			<b-btn variant="info" class="mr-2 mt-2" @click="showLogin = false; showWaiting = false; isReviewing = true">
				<i class="fas fa-search pr-1" />
				Review Images
			</b-btn>
		</div>-->

		<b-modal 	v-model="showLogin" 
					centered 
					hide-footer
					:title="`Entering '${$route.query.name}'`" 
					:no-close-on-backdrop="true"
					:no-close-on-esc="true"
					:hide-header-close="true"
		>
			<b-form-group 	id="usernameInputLabel"
							label="User Name:"
							label-for="usernameInput"
							:state="errors.has('username')? false : null"
							:invalid-feedback="errors.first('username')"
			>
				<b-form-input 	id="usernameInput"
								name="username"
								type="text"
								v-model="username"
								required
								placeholder="Loading..."
								v-validate="'required'"
								:state="errors.has('username')? false : null"
				>
				</b-form-input>
			</b-form-group>
			
			<b-form-group 	v-if="!query.has('room')"
							id="roomInputLabel"
							label="Room:"
							label-for="roomInput"
							:state="errors.has('room')? false : null"
							:invalid-feedback="errors.first('username')"
			>
				<b-form-input 	id="roomInput"
								name="room"
								type="text"
								v-model="currentRoom"
								required
								placeholder="Enter room to join"
								v-validate="'required'"
								:state="errors.has('room')? false : null"
				>
				</b-form-input>
			</b-form-group>
			
			<div class="pb-3 pt-2 text-center"> 
				Are you a viewer or a host?
			</div>

			<b-row class="text-center pb-3">
				<b-col md=4>
					<b-btn 	variant="primary"
							class="w-75"
							@click="onStart(onViewerEnter)"
					>
						Viewer
					</b-btn>
				</b-col>
				<b-col md=4>
					<b-btn 	variant="success"
							class="w-75 mt-2 mt-md-0"
							@click="onStart(onHostEnter)"
					>
						Host
					</b-btn>
				</b-col>

				<b-col md=4>
					<b-btn 	
							class="w-75 mt-2 mt-md-0"
							:to="{ name: 'Dashboard' }"
					>
						Cancel
					</b-btn>
				</b-col>

				
			</b-row>

			<!--<b-form-group label="Options"> 
				<b-btn 	:variant="sendAudio? 'outline-success' : 'secondary'"
						@click="sendAudio = !sendAudio"
						class="mr-2"
				>
					<i v-if="sendAudio" class="fas fa-microphone" />
					<i v-else class="fas fa-microphone-slash" />
				</b-btn>

				<b-btn 	:variant="sendVideo? 'outline-primary' : 'secondary'"
						@click="sendVideo = !sendVideo"
				>
					<i v-if="sendVideo" class="fas fa-video" />
					<i v-else class="fas fa-video-slash" />
				</b-btn>
			</b-form-group>-->
			
			<div slot="modal-footer" class="w-100"></div>
		</b-modal>
		
		<b-modal 	v-model="showWaiting" 
					centered title="Waiting for host to accept..." 
					:no-close-on-backdrop="true"
					:no-close-on-esc="true"
					:hide-header-close="true"
		>
			<div class="text-center">
				<i class="fas fa-spinner fa-spin fa-2x"></i>
			</div>
			<div slot="modal-footer" class="w-100"></div>
		</b-modal>
	</div>




	<div v-else-if="isReviewing">
		<review @back="showLogin = true; isReviewing = false" />
	</div>




	<!-- Main Screen -->
	<div v-else style="max-width: 100px; max-height: 100vh">

		<!-- Nav Bar -->
		<!--<b-navbar toggleable="md" type="dark" variant="light" style="border-bottom: 1px gainsboro solid; z-index: 1000">
		<b-navbar-brand href="#" class="pb-2"><b-img src="/logo.png" style="max-height: 20px!important" class="mb-1" /></b-navbar-brand>

		<b-collapse is-nav id="nav_collapse">

					<b-navbar-nav class="ml-auto p-1">

		<b-img style="max-height: 40px" src="/smartscope.png"/>
		</b-navbar-nav>

		</b-collapse>
		</b-navbar>-->

		<!-- Video -->

		
		<video id="largeVideo" 	style="position: fixed; bottom: 0; right: 0; min-width: 100%; min-height: 100%" 
								:muted="isHost? localVideoMuted : false"
							
		/>
        <!-- @click="samplePosition(x, y, $event)" -->
		<div style="position: absolute; max-width: 20%; max-height: 20% ">
				<!-- <canvas style="border: 3px solid red ; margin-left: 50px; margin-top: 5px" ref="canvas" id="canvas"
				width="210px" height="70px">
				</canvas> -->
				<!-- var yPost = {{microscope.position.Y}};
		var x = {{microscope.scan.X[1] - microscope.position.x}}
		var yScan = {{microscope.scan.y[1] - microscope.position.y}}
		var pSlide = {{microscope.pSlide}} -->

        <!-- var yCorrectF = ({{microscope.position.Y}} * {{microscope.scan.X[1] - microscope.position.x}})/
					({{microscope.scan.y[1] - microscope.position.y}}*{{microscope.pSlide}}) -->
		<!-- the outer border--->
				<v-stage  style="border: 2px solid orange" ref="stage" :config="configKonva">
					
				<v-layer>
					<!-- <v-circle :config="configCircle"/> -->
					<!-- let xValue === {{microscope.position.x}},
					let yValue === {{microscope.position.y}}, -->
					<!-- vslide rectangular ----->

					
					<v-rect style="border: 3px solid red" :config="configKonvaSlide"
						
					/>
				
					<v-circle :config="configKnovaCircle"
						
					/> 

					<!-- {
						x:100,   // max 200
						y:50,      //max=70
						radius: 30,
						fill: 'blue',
						stroke: 'blue',
						strokeWidth: 1
						} -->
					<v-circle :config="configKnovaMPost"
					/>
					<!-- </v-rect>			   -->
				</v-layer>
				</v-stage>

				<b> x: {{microscope.position.x}}
					y: {{microscope.position.y}}</b> 
				

        </div>
		
		<div style="position: absolute; right: 0; left: 0; bottom: 0; top: 0">

			


			<div @click="moveMicroscope(`mcommand: Y ,${movementAmountY},${speed}#`)" 
			class="edge-button text-center d-flex" 
			style="position: absolute; top: 68px; left: 0; right: 0; height: 10vh; background-image: linear-gradient(to bottom, #88888888, #ffffff00); opacity: 0;">
				<div class="flex-fill align-self-center text-center">
					<i class="fas fa-chevron-up fa-2x"></i>
				</div>
			</div>

			<div @click="moveMicroscope(`mcommand: Y ,-${movementAmountY},${speed}#`)" 
			class="edge-button text-center d-flex" 
			style="position: absolute; bottom: 70px; left: 0; right: 0; height: 10vh; background-image: linear-gradient(to top, #88888888, #ffffff00); opacity: 0;">
				<div class="flex-fill align-self-center text-center">
					<i class="fas fa-chevron-down fa-2x"></i>
				</div>
			</div>

			<div @click="moveMicroscope(`mcommand:X  ,${movementAmountX},${speed}#`)" 
			class="edge-button text-center d-flex" 
			style="position: absolute; bottom: 0; left: 0;  top: 0; width: 10vh; background-image: linear-gradient(to right, #88888888, #ffffff00); opacity: 0;">
				<div class="flex-fill align-self-center text-center">
					<i class="fas fa-chevron-left fa-2x"></i>
				</div>
			</div>

			<div @click="moveMicroscope(`mcommand:X  ,-${movementAmountX},${speed}#`)" 
			class="edge-button text-center d-flex" 
			style="position: absolute; bottom: 0; right: 0;  top: 0; width: 10vh; background-image: linear-gradient(to left, #88888888, #ffffff00); opacity: 0;">
				<div class="flex-fill align-self-center text-center">
					<i class="fas fa-chevron-right fa-2x"></i>
				</div>
			</div>
		</div>

		<div class="text-center" style="position: absolute; right: 0; left: 0; bottom: 5px; " >
			<div class="d-inline">
				<b-btn 	:variant="videosMuted? 'secondary' : 'primary'"
						@click="videosMuted = !videosMuted"
						class="mb-3 mr-2"
						v-b-tooltip.hover
						title="Toggle audio"
				>
					<i v-if="videosMuted" class="fas fa-volume-off" />
					<i v-else class="fas fa-volume-up" />
				</b-btn>

				<b-btn 	:variant="!cameraEnabled? 'secondary' : 'primary'"
						@click="cameraEnabled = !cameraEnabled"
						class="mb-3 mr-2"
						v-b-tooltip.hover
						title="Toggle video"
				>
					<i v-if="!cameraEnabled" class="fas fa-video-slash" />
					<i v-else class="fas fa-video" />
				</b-btn>

				<b-btn variant="info" class="mb-3 mr-2" @click="takeScreenshot" v-b-tooltip.hover 
				title="Take screenshot for review">
					<i class="fas fa-camera"></i>
				</b-btn>

				<b-btn 	class="mb-3 "
						:to="{ name: 'Dashboard' }"
						v-b-tooltip.hover
						title="Exit"
				><i class="fas fa-window-close"></i></b-btn>
			</div>
		</div>


		<div class="d-flex" style="position: absolute; max-width: 400px; right: 5px; bottom: 5px; " 
		:style="{ 'max-height': (windowHeight - 76) + 'px' }" >
			<div class="align-self-end">
				<b-btn 	class="p-2 mb-3 mr-3" 
						:variant="showSidebar? 'light' : 'secondary'"
						@click="showSidebar = !showSidebar"
						v-b-tooltip.hover
						:title="(showSidebar? 'Hide' : 'Show') + ' sidebar'"
				>
					<i v-if="!showSidebar" class="far fa-eye px-1" />
					<i v-else class="far fa-eye-slash px-1" />
				</b-btn>
			</div>

			<!-- user, chat, Microscope -->
			<div v-show="showSidebar" style="flex: 1">
				<b-card no-body class="pb-2" style="max-height: calc(100vh - 80px); overflow-y: auto">
					<b-tabs card>
						<!----Users------------>
						<b-tab title="Users" active>
							<div class="pb-2 text-left" v-if="isHost">
								<div><b>Room:</b> {{ $route.query.name }}</div>
								<b-checkbox v-model="autoConfirmCalls">Accept incoming calls</b-checkbox>
							</div>

							<div class="my-2" style="background-color: gainsboro; height: 1px" />

							<b-list-group v-if="isHost && videos.length == 0">
								<b-list-group-item variant="light">No users have joined.</b-list-group-item>
							</b-list-group>

							<!-- My Video -->
							<div v-if="!isHost" style="padding: 8px; height: 120px">
								<video id="topRightVideo" style="background-color: black; height: 120px; width: 50%; float: left" :muted="localVideoMuted">
								</video>
								<div style="height: 120px; float:left; padding: 0px 12px">
									<h5>You</h5>
									<b-btn v-if="isHost" variant="danger" size=sm><i class="far fa-times-circle pr-1"></i>Disconnect</b-btn><br>
									<b-btn v-if="isHost" size=sm variant="primary" class="mt-1"><i class="fas fa-key pr-1"></i>Make Admin</b-btn>
								</div>
							</div>

							<!-- Other user videos -->
							<div v-for="(video,index) in videos" :key="video.id">
								<video-control  :caller-id="video.id" :stream="video.stream" :nickname="nicknames[video.id]" @hangup="onHangup(index)" :current-z="currentZ" :muted="videosMuted" :admin="areAdmins[video.id]" />
							</div>

							<div v-for="(user,index) in newUsers" :key="user.who">
								<div style="background-color: gainsboro; height: 1px" class="my-2" />
								{{nicknames[user.who]}} wants to join{{ user.admin? ' as admin' : '.' }} <br>

								<div class="pt-1">
									<b-btn size=sm variant="success" class="mr-2" @click="user.func();
									newUsers.splice(index, 1)">Allow</b-btn>
									<b-btn size=sm variant="danger" 
									@click="newUsers.splice(index, 1)">Decline</b-btn>
								</div>
							</div>
						</b-tab>
<!-- chat-------------------------------------------------------------->

						<b-tab title="Chat" @click="unreadMessages = 0">
							<template slot="title">
								Chat 
								<small><b-badge v-if="unreadMessages > 0" class="" variant="primary">{{ unreadMessages }}</b-badge></small>
							</template>

							<b-card class="mt-2" style="height: 50vh; overflow-y: auto  " ref="messageArea">
								<div v-for="(msg, index) in messages" :key="index" class="text-left">
									<template v-if="msg.type==='join'">
										<b>System:</b> {{nicknames[msg.who]}} wants to join{{ msg.admin? ' as admin' : '.' }} <br>

										<div class="pt-2">
											<b-btn size=sm variant="success" class="mr-2" @click="msg.func(); messages.splice(index, 1)">Allow</b-btn>
											<b-btn size=sm variant="danger" @click="messages.splice(index, 1)">Decline</b-btn>
										</div>
									</template>
									
									<template v-else-if="msg.type==='text'">
										<b>{{nicknames[msg.who]}}:</b> {{msg.text}}
									</template>
									
									<template v-else-if="msg.type==='system'">
										<b>System:</b> {{msg.text}}
									</template>
									
								</div>
							</b-card>
							<div style="style: relative; bottom: 0px" class="mt-2">
								<b-input-group>
									<b-input v-model="message" @keyup.native.enter="sendMessage"></b-input>
									<b-input-group-append>
										<b-btn variant="primary" @click="sendMessage"><i class="far fa-comment"></i></b-btn>
									</b-input-group-append>
								</b-input-group>
							</div>
						</b-tab>
<!-- Microscope-------------------------------------------------------------->
						<b-tab title="Microscope">
							<b-card v-if="isHost" no-body class="py-3 px-3 mb-2">
								<h6 @click="showSample = !showSample" class="mb-0" style="cursor: pointer">Objective Lens</h6>
								<div v-if="showSample" class="pt-3">
									<b-select v-model="objectiveLens" :options="objectiveLensOptions" @input="updateLens"/>

									<h6 class="mt-2">Sample</h6>
									<b-btn @click="$refs.sampleModal.show()">Edit sample</b-btn>
								</div>
								<small v-else class="text-muted">Click to open settings.</small>
							</b-card>

							<b-card v-if="isHost || showMicroscopeControls" no-body class="py-3 px-3 mb-2">
								<h6>Zoom</h6>

								<div>
									<small class="float-right mb-0 pb-0">{{microscope.features.z}}</small>
									<small class="float-left mb-0 pb-0">{{0}}</small>
								</div>

								<b-input 	type="range" 
											size=sm
											:min="0" :max="microscope.features.z" 
											:disabled="true" 
											:value="microscope.position.z" 
								/>

								<b-input-group v-if="showMicroscopeControls && microscope.features.z">
									<b-input 	type="number"
												:min="0" :max="microscope.features.z"
												v-model="currentZ" 
												@keyup.enter.native="moveMicroscopeZ"
									/>
									
									<b-input-group-addon>
										<b-btn variant="primary" @click="moveMicroscopeZ">Go</b-btn>
									</b-input-group-addon>

									<b-input 	type="number" 
												:disabled="true" 
												:value="microscope.position.z" 
									/>

								</b-input-group>

								<div  v-if="showMicroscopeControls && microscope.features.z" class="d-flex pt-2">
									<!--<b-btn variant="danger" class="mr-2" @click="moveMicroscope(`mcommand:  Z,0,100 #`);">Stop</b-btn>-->
									<div class="flex-fill align-self-center">
										<b-btn block variant="warning" @click="moveMicroscope('mcommand:HZ  #');"><i class="fas fa-home pr-2"></i>Home Z</b-btn>
									</div>

									<div class="pl-2">
										<div>
											<b-btn @click="moveMicroscope(`mcommand:  Z,-1,5#`)" class="mb-2"><i class="fas fa-arrow-up"></i></b-btn>
										</div>
										<div>
											<b-btn @click="moveMicroscope(`mcommand:  Z,1,5#`)"><i class="fas fa-arrow-down"></i></b-btn>
										</div>
									</div>
								</div>
							</b-card>
							
							<!--<div v-if="microscope.features.z">
								Zoom
								
								<b-input 	type="range" 
											v-if="showMicroscopeControls"
											:min="-3000" :max="microscope.features.z" 
											v-model="currentZ" 
											:disabled="!!microscope.status.z"
											@input="moveMicroscopeZ"></b-input>
							</div>-->
							
						<!-- X,Y Movement ----->	

							<b-card v-if="showMicroscopeControls && (microscope.features.x || microscope.features.y)" class="mb-2">
								<h6>Movement</h6>

								<div class="text-center" v-if="showMicroscopeControls && microscope.features.y">
									<b-btn @click="moveMicroscope(`mcommand: Y ,${-microscope.position.y},5#`)">
										<i class="fas fa-angle-double-up"></i></b-btn>
								</div>
								<div class="text-center"  v-if="showMicroscopeControls && microscope.features.x">
									<b-btn @click="moveMicroscope(`mcommand:X  ,${microscope.scan.X[1] - microscope.position.x},5#`)">
										<i class="fas fa-angle-double-left"></i></b-btn>
									<b-btn @click="moveMicroscope(`mcommand:XYZ,0,100 #`);" variant="danger" class="m-1">
										<i class="fas fa-stop-circle"></i></b-btn>
									<b-btn @click="moveMicroscope(`mcommand:X  ,${-microscope.position.x},5#`)">
										<i class="fas fa-angle-double-right"></i></b-btn>
								</div>
								<div class="text-center"  v-if="showMicroscopeControls && microscope.features.y">
									<b-btn @click="moveMicroscope(`mcommand: Y ,${microscope.scan.Y[1] - microscope.position.y},5#`)">
										<i class="fas fa-angle-double-down"></i></b-btn>
								</div>

								<div class="d-flex pt-3">
									<div  v-if="showMicroscopeControls && (microscope.features.x || microscope.features.y)" class="flex-fill">
										<b-btn block variant="warning" @click="moveMicroscope('mcommand:HXY  #');"><i class="fas fa-home pr-2">
											</i>Home XY</b-btn>
									</div>

								</div>
							</b-card>
							
							
								<!-- <div class="text-center" v-if="showMicroscopeControls && microscope.features.y">
									<b-btn @click="moveMicroscope(`mcommand: Y ,${movementAmountY},${speed}#`)"><i class="fas fa-angle-double-up"></i></b-btn>
								</div>
								<div class="text-center"  v-if="showMicroscopeControls && microscope.features.x">
									<b-btn @click="moveMicroscope(`mcommand:X  ,-${movementAmountX},${speed}#`)"><i class="fas fa-angle-double-left"></i></b-btn>
									<b-btn @click="moveMicroscope(`mcommand:XYZ,0,100 #`);" variant="danger" class="m-1"><i class="fas fa-stop-circle"></i></b-btn>
									<b-btn @click="moveMicroscope(`mcommand:X  ,${movementAmountX},${speed}#`)"><i class="fas fa-angle-double-right"></i></b-btn>
								</div>
								<div class="text-center"  v-if="showMicroscopeControls && microscope.features.y">
									<b-btn @click="moveMicroscope(`mcommand: Y ,-${movementAmountY},${speed}#`)"><i class="fas fa-angle-double-down"></i></b-btn>
								</div> -->
							

<!----------Lighting---------------------------->
							<b-card class="mb-2">
								<h6 @click="showLighting = !showLighting" class="mb-0" style="cursor: pointer">Lighting</h6>

								<div v-if="showLighting" class="pt-3">
									<div>
										<small class="float-right mb-0 pb-0">{{5}}</small>
										<small class="float-left mb-0 pb-0">{{0}}</small>
									</div>

									<b-input 	type="range" 
												:min="0" :max="5" 
												v-model="lighting" 
												@change="setLighting"
												:disabled="manualLighting || !showMicroscopeControls"
									/>
									
									<b-checkbox		v-if="isHost"
													v-model="manualLighting"
													@input="manualLighting? setLighting(-1) : setLighting(lighting)"
													disabled
													class="pb-2"
									> 
										Manual Lighting 
									</b-checkbox>
								</div>
								<small v-else class="text-muted">Click to open settings.</small>
							</b-card>

							<!--------AutoFocus---------->

							<b-card class="mb-2">
								<h6>Autofocus</h6>
								
								<b-checkbox		v-if="showMicroscopeControls"
												v-model="microscope.autofocus"
												@input='microscope.autofocus? moveMicroscope(`{ "setAutofocus": true }`) : moveMicroscope(`{ "setAutofocus": false }`)'
												class="pb-2"
								> 
									Enable Autofocus
								</b-checkbox>
							</b-card>
							
							
						<!-----Position----------------->	
							<b-card>
								<b>Position</b><br>
								X: {{microscope.position.x}}<br>
								Y: {{microscope.position.y}}<br>
								Z: 
								<span v-if="!inputZ" @click="inputZ=true; tempZ = currentZ">{{microscope.position.z}}</span>
								<b-input-group v-else>
									<input v-model.number="tempZ">
									<b-input-group-append>
										<b-btn variant="primary" @click="currentZ = tempZ; moveMicroscopeZ(); inputZ = false">Go</b-btn>
										<b-btn variant="danger" @click="inputZ = false">Cancel</b-btn>
									</b-input-group-append>
								</b-input-group>
								<br>
								
							</b-card>
						<!----------------------------------------------->	
							<b-card class="">
								<h6>Motor Movement</h6>
								X: <i class="fas fa-circle-notch mr-3" :class="{'fa-spin': microscope.status.x }"></i>
								Y: <i class="fas fa-circle-notch mr-3" :class="{'fa-spin': microscope.status.y }"></i>
								Z: <i class="fas fa-circle-notch" :class="{'fa-spin': microscope.status.z }"></i>
							</b-card>
						</b-tab>
					</b-tabs>
				</b-card>
			</div>
		</div>

<!------->
		<!-- <video id="largeVideo" :style="{ height: `${windowHeight - 76}px` }" style="width:100%; padding: 0px; box-sizing: border-box; float: left; background-color: red" :muted="isHost? localVideoMuted : false"></video>
		
		<div :style="'position: absolute; right: 0px; background-color: white; min-height: ' + windowHeight + 'px'" class="p-2">
			<div class="text-right pb-2">
				<b-btn @click="showSidebar = !showSidebar">
					<i v-if="showSidebar" class="fas fa-chevron-right"></i>
					<i v-else class="fas fa-chevron-left"></i>
				</b-btn>
			</div>
			
			<b-tabs v-show="showSidebar">
				<b-tab title="Connected Videos" active>
				<div class="p-2" v-if="!isHost"></div>
				<div v-if="!isHost" style="padding: 8px; height: 120px">
					<video id="topRightVideo" style="background-color: black; height: 120px; width: 50%; float: left" :muted="localVideoMuted">
					</video>
					<div style="height: 120px; float:left; padding: 0px 8px">
						<h5>You</h5>
						<b-btn v-if="isHost" variant="danger" size=sm><i class="far fa-times-circle pr-1"></i>Disconnect</b-btn><br>
						<b-btn v-if="isHost" size=sm variant="primary" class="mt-1"><i class="fas fa-key pr-1"></i>Make Admin</b-btn>
					</div>
				</div>
				
				<div v-for="(video,index) in videos" :key="video.id">
					<video-control  :caller-id="video.id" :stream="video.stream" :nickname="nicknames[video.id]" @hangup="onHangup(index)" :current-z="currentZ" />
				</div>
				
			</b-tab>
			<b-tab :title="'Chat' + (unreadMessages? ('('+unreadMessages+')') : '')" @click="unreadMessages = 0">

			</b-tab>
			<b-tab title="Microscope" >


			</b-tab>
			</b-tabs>
		</div> -->
<!------------->
		<b-modal title="Edit Sample Settings" ref="sampleModal" @ok="sendSample">
			<b-form-group label="Sample ID">
				<b-input v-model="sampleId" />
			</b-form-group>

			<b-form-group label="Sample Name">
				<b-input v-model="sampleName" />
			</b-form-group>
		</b-modal>


		<b-modal title="Save Screenshot" ref="screenshotModal" @ok="saveScreenshot">
			<b-img responsive thumbnail :src="screenshot" />

			<b-form-group label="Comments">
				<b-textarea rows=3 v-model="comments" />
			</b-form-group>
		</b-modal>

		
		<b-modal ref="bla">
		</b-modal>
	</div>
		
</template>

<script>
import VideoControl from './VideoControl';
import Review from './Review'
import axios from 'axios'
import Vue from 'vue';
import VueKonva from 'vue-konva'

Vue.use(VueKonva)
//const WebSocket = require('ws');

const baseUrl = process.env.VUE_APP_SERVER;//'https://ed.smartlabsltd.com';
//const width = window.innerWidth;
//const height = window.innerHeight;
// var yPost = this.microscope.position.Y;
// var xScan = this.microscope.scan.X[1] - this.microscope.position.x
// var yScan = this.microscope.scan.y[1] - this.microscope.position.y
// var pSlide = this.microscope.pSlide

// var yCorrectF = (yPost * xScan)/(yScan*pSlide)
// var hiddenWidth = 0.2 * screen.width
// var hiddenHeight = ((yCorrectF * this.microscope.features.y)/this.microscope.features.x)* hiddenWidth;
export default {
	name: 'MicroscopeView',
	props: {
		msg: String
	},
	components: { VideoControl, Review },

	data() {
		return {

			// vueCanvas: null,
			// rectWidth: 200,
			// hiddenWidth: 0.2 * window.innerWidth,
			// 
			// configSlideKonva: {
			// 	// width: 0.2 * window.innerWidth,
			// 	// maxwidth : 200,
			// 	// height: 0.3 * 0.2*screen.width,
			// 	width: 150,
			// 	height: 50,

			// },
			configCircle: {
				x: 70,
				y: 50,
				radius: 5,
				fill: "green",
				stroke: "black",
				strokeWidth: 1
			},

			windowHeight: -1,
			showLogin: true,
			showWaiting: false,
			isReviewing: false,
			showSidebar: true,
			inputX: false,
			inputY: false,
			inputZ: false,

			currentRoom: '',
			users: [],
			nicknames: {},
			host: {},
			autoConfirmCalls: false,
			microscopeSocket: null,
			localVideoMuted: false,
			unreadMessages: 0,

			sampleId: 0,
			sampleName: '',

			requestsInChat: {},

			messages: [],
			newUsers: [],
			areAdmins: {},

			isHost: false,
			isAdmin: false,
			canControlMicroscope: false,
			username: '',
			userId: '',
			room: '',
			easyrtcId: '',

			sendAudio: true,
			sendVideo: true,

			cameraEnabled: true,
			videosMuted: false,

			showSample: false,
			showLighting: false,

			screenshot: '',
			comments: '',

			message: '',
			videos: [],

			microscope: {
				intialized: false, 
				features: { x: 300, y: 100, z: 1000 },  // all 100
				position: { x: -1, y: -1, z: -1 },
				status: { x: -1, y: -1, z: -1 },
				autofocus: false,
				scan: { X: [0,100], Y: [0,100], Z:[0,100] },
				pSlide: { X: 3, Y: 1 },
				lens: {x: 50, y:50}
			},
			tempX: -1,
			tempY: -1,
			tempZ: -1,
			currentZ: -1,
			lighting: -1,
			manualLighting: false,
			movementAmountX:5,
			movementAmountY:5,
			speed: 2,

			imageSequenceTimer: 0,

			lastMicroscopeMessageRecieved: -1,

			objectiveLens: 40,
			objectiveLensOptions: [
				{ value: 4, text: '4X' },
				{ value: 10, text: '10X' },
				{ value: 40, text: '40X' },
				{ value: 100, text: '100X' }
			],

			
		};
	},

	created(){
		if(!this.w){
			this.w = window.innerWidth * 0.2;
			this.h = this.w /3;
		}
	},

	async mounted() {
		
		
		if (this.query.has('room')) {
			this.currentRoom = this.query.get('room');
		}

		this.easyrtcId = easyrtc.myEasyrtcid;
		var user = await this.$app.service('users').get('$userId');
		this.username = user.username || (user.firstName + ' ' + user.lastName);
		this.userId = user._id;

		this.initEasyrtc();

		//
		this.windowHeight = window.innerHeight;
		window.onresize = () => {
			this.$nextTick(() => {this.windowHeight = window.innerHeight
				const _this = this;
				_this.w = window.innerWidth * 0.2;				
				//var yPost = _this.microscope.position.y;
				const xScan = _this.microscope.scan.X[1] - _this.microscope.scan.X[0]
				const yScan = _this.microscope.scan.Y[1] - _this.microscope.scan.Y[0]
				const pSlide = _this.microscope.pSlide

				const yCorrectF = ( xScan * pSlide.Y) /(yScan*pSlide.X)
				_this.h = _this.w * yCorrectF * _this.microscope.features.y/ _this.microscope.features.x
				//alert(`W= ${this.w}, h= ${this.h}`)
			});
		
		// var c = document.getElementById("c");
		// var ctx = c.getContext("2d");    
		// this.vueCanvas = ctx;
		};
	},

	computed: {
		showMicroscopeControls() {
			return this.isHost || this.canControlMicroscope || this.isAdmin;
		},

		query() {
			return new URLSearchParams(window.location.search);
		},
		//yHiddenHeight(){
			//console.log("test2")
		// var yPost = this.microscope.position.Y;
		// var xScan = this.microscope.scan.X[1] - this.microscope.position.x
		// var yScan = this.microscope.scan.y[1] - this.microscope.position.y
		// var pSlide = this.microscope.pSlide

        // var yCorrectF = (yPost * xScan)/(yScan*pSlide)
		// return  yCorrectF * this.microscope.features.x/ this.microscope.features.x
		//return 100
		//},
// the outer hidden area
		configKonva(){ 
			//console.log("test2")
			return{
					width: this.w,  //300,
					height:this.h,  // 300,
					x: 27,
					y:5,
			}

			// 		height: ()=>{
			// 			// eslint-disable-next-line no-console
			// 			console.log("test") 
			// 			var yPost = this.microscope.position.Y;
			// 		console.log("yPost",yPost)
			// var xScan = this.microscope.scan.X[1] - this.microscope.position.x
			// console.log("xScan",xScan)
			// var yScan = this.microscope.scan.y[1] - this.microscope.position.y
			// console.log("yScan",yScan)
			// var pSlide = this.microscope.pSlide
			// console.log("pSlide",pSlide)

			// var yCorrectF = (yPost * xScan)/(yScan*pSlide)
			// console.log("yCorrectF",yCorrectF)
			// return  yCorrectF * this.microscope.features.x/ this.microscope.features.x}

			},
// the slide area		
		configKonvaSlide(){
			
			let xwidth =
				(((this.microscope.scan.X[1])/this.microscope.features.x)-
				((this.microscope.scan.X[0])/this.microscope.features.x))*this.w
			
			let yheight =
				(((this.microscope.scan.Y[1])/this.microscope.features.y)-
				((this.microscope.scan.Y[0])/this.microscope.features.y))*this.h

		
		return {
			width: xwidth,
			height: yheight,
			//x: 27,
			//y: 5,
			stroke: 'red',
		}
		},

// the sample circle area
		configKnovaCircle(){

			let xLens= (this.microscope.lens.x/this.microscope.features.x) * this.w
			let yLens= (this.microscope.lens.y/this.microscope.features.y) * this.h

			return{
				x: xLens,
				y: yLens,
				//x:xValue(),   // max 200
				//y:yValue(),      //max=70
				radius: 40,
				fill: 'green',
				stroke: 'black',
				strokeWidth: 1
			}

		},

// the Microscope position

		configKnovaMPost(){

			let xPost= (this.microscope.position.x/this.microscope.features.x) * this.w
			let yPost= (this.microscope.position.y/this.microscope.features.y) * this.h

			return{
				x: xPost,
				y: yPost,
				//x:xValue(),   // max 200
				//y:yValue(),      //max=70
				radius: 7,
				fill: 'blue',
				stroke: 'black',
				strokeWidth: 1
			}

		},
	},

	watch: {
		sendAudio() {
			easyrtc.enableAudio(this.sendAudio);
		},

		sendVideo() {
			easyrtc.enableCamera(this.sendVideo);
		},

		cameraEnabled() {
			easyrtc.enableCamera(this.cameraEnabled);
		}
	},


	methods: {
		

		yHeight() {
			(((this.microscope.scan.y[1])/this.microscope.features.y)-
				((this.microscope.scan.y[0])/this.microscope.features.y))*y
		},
	// samplePosition(x, y, event) {
    //    x = event.pageX;
	//    y = event.pageY;

	//   console.log(event.pageX) 
    //   console.log(event.pagey) 
	// },

	// drawRect() {
    //   // clear canvas
    //   this.vueCanvas.clearRect(0, 0, 400, 200);
      
    //   // draw rect
    //   this.vueCanvas.beginPath();
    //   this.vueCanvas.rect(20, 20, this.rectWidth, 100);
    //   this.vueCanvas.stroke();      
	// },

	// yCorrectFactor(yCorrectF){

		
	// 	return yCorrectF;
	// },

	// yHiddenHeight(){
	// 	var yPost = this.microscope.position.Y;
	// 	var xScan = this.microscope.scan.X[1] - this.microscope.position.x
	// 	var yScan = this.microscope.scan.y[1] - this.microscope.position.y
	// 	var pSlide = this.microscope.pSlide

    //     var yCorrectF = (yPost * xScan)/(yScan*pSlide)
	// 	return  yCorrectF * this.microscope.features.x/ this.microscope.features.x
	// },
	
	
		xValue() {
		// this.rectWidth += 10
		// this.drawRect()
		var xpos = this.microscope.position.x
		return (
		(xpos)/7
		)
		},

		yValue() {
		// this.rectWidth -= 10
		// this.drawRect()  
		var ypos = this.microscope.position.y
		return (
		(ypos)/10
		)    
		},

		initEasyrtc() {
			var iceServers = {
				iceServers: [
					{ url: 'stun:35.182.18.16:3478' },
					{
						url: 'turn:52.60.81.70:3478?transport=udp',
						credential: 'mm',
						username: 'mm'
					},
					{
						url: 'turn:52.60.81.70:3478?transport=tcp',
						credential: 'mm',
						username: 'mm'
					}
				]
			};

			easyrtc.setIceUsedInCalls(iceServers);

			// Server URL
			easyrtc.setSocketUrl(process.env.VUE_APP_EASYRTC_URL);

			// Data listener
			easyrtc.setPeerListener(this.onPeerData);

			// Call managers
			easyrtc.setStreamAcceptor(this.onStreamAccept);
			easyrtc.setOnStreamClosed(this.onStreamClose);

			easyrtc.connect(
				'microscope',
				this.onLoginSuccess,
				this.onLoginFailure
			);
		},

		onMediaStart() {
			// Init local media
			easyrtc.initMediaSource(this.onMediaInit);
		},

		onMediaInit() {
			easyrtc.setVideoObjectSrc(
				document.getElementById(
					this.isHost ? 'largeVideo' : 'topRightVideo'
				),
				easyrtc.getLocalStream()
			);

			if (!this.isHost) {
				for (var user in this.users) {
					easyrtc.call(user);
				}
			}

			this.localVideoMuted = true;
		},

		onRoomOccupant(roomName, data, isPrimary, isHost) {
			easyrtc.sendDataWS({ targetRoom: this.currentRoom }, 'nickname', {
				nickname: this.username
			});
			easyrtc.sendDataWS({ targetRoom: this.currentRoom }, 'who-host');

			if (this.isHost) {
				easyrtc.sendDataWS({ targetRoom: this.currentRoom }, 'is-host');
				this.sendSample();
			}

			if (this.showWaiting) {
				easyrtc.sendDataWS(
					{ targetRoom: this.currentRoom },
					'can-call'
				);
			}

			/*for (var user in data) {
			if (!users[user]) {
				users[user] = { id: user };
				
				if (this.isHost) {
					//easyrtc.sendDataWS(user, 'microscope-control', { enabled: microscopeControlsEnabled });
				}
			}
		}*/

			this.users = data;
		},

		onStreamClose(callerEasyrtcId) {
			/*var video = videoElements[callerEasyrtcId];
		easyrtc.setVideoObjectSrc(video, "");
		video.remove();
		
		delete videoElements[callerEasyrtcId];*/
		},

		onStreamAccept(callerEasyrtcId, stream) {
			if (this.host[callerEasyrtcId]) {
				var el = document.getElementById('largeVideo');
				easyrtc.setVideoObjectSrc(el, stream);
			} else {
				if (!this.isHost) {
					console.log('AM NOT HOST');
					//easyrtc.hangup(callerEasyrtcId);
				} else {
					// TODO: Multi videos
					this.videos.push({ id: callerEasyrtcId, stream: stream });
					/*var el = document.createElement('video');
				el.style = "padding: 0px 8px; width: 100%";
				videoPanel.appendChild(el);
				
				easyrtc.setVideoObjectSrc(el, stream);
				
				videoElements[callerEasyrtcId] = el;*/
				}
			}
		},

		onLoginSuccess(id) {
			this.easyrtcId = id;
			console.log(id);
		},

		onLoginFailure() {
			console.log('Failure to connect.');
		},

		onPeerData(who, msgType, content) {
			//console.log(msgType);

			switch (msgType) {
				case 'text-message':
					this.onTextMessage(who, content);
					break;
				case 'image-message':
					this.onImageMessage(who, content);
					break;
				case 'microscope-command':
					if (this.isHost) this.moveMicroscope(content);
					break;
				case 'nickname':
					this.nicknames[who] = content.nickname;
					break;
				case 'who-host':
					if (this.isHost) easyrtc.sendDataWS(who, 'is-host');
					break;
				case 'is-host':
					this.host[who] = true;
					if (this.showWaiting) {
						easyrtc.sendDataWS(who, 'can-call');
					}
					break;
				case 'can-call':
					if (this.isHost || this.isAdmin) {
						this.onCall(who);
					}
					break;
				case 'confirm-call':
					this.onCallAccepted(content);
					this.isAdmin = content;
					break;
				case 'grant-admin':
					this.isAdmin = !this.isAdmin;
					this.messages.push({
						type: 'system',
						text: 'Admin permissions have been set to ' + this.isAdmin
					});
					break;
				case 'join-admin':
					if (this.isHost) {
						this.onCall(who, true);
					}
					break;
				case 'microscope-update':
					this.$set(this, 'microscope', content);
					if (this.currentZ === -1) {
						this.currentZ = this.microscope.position.z;
					}
					break;
				case 'microscope-grant-control':
					this.currentZ = content;
					this.canControlMicroscope = !this.canControlMicroscope;
					this.messages.push({
						type: 'system',
						text: this.canControlMicroscope
							? 'You have control of the microscope'
							: 'You do not have control of the microscope'
					});
					break;
				case 'sample-details':
					this.sampleId = content.id,
					this.sampleName = content.name
					break;
				case 'lighting':
					this.lighting = content;
			}
		},

		onTextMessage(who, content) {
			var messageArea = this.$refs.messageArea;

			this.messages.push({
				type: 'text',
				who: who,
				text: content.text
			});

			setTimeout(function() {
				messageArea.scrollTop = messageArea.scrollHeight;
			}, 1);
			this.unreadMessages += 1;
		},

		onCall(who, admin) {
			if (this.autoConfirmCalls && !admin) {
				easyrtc.sendDataWS(who, 'confirm-call');
			} else {
				if (this.requestsInChat[who]) {
					return;
				}

				if (this.nicknames[who] == '$admin') {
					easyrtc.sendDataWS(who, 'confirm-call', admin);
					easyrtc.sendDataWS(
						{ targetRoom: this.currentRoom },
						'microscope-update',
						this.microscope
					);
					return;
				}

				this.requestsInChat[who] = true;

				var messageArea = this.$refs.messageArea;

				this.newUsers.push({
					who: who,
					admin: admin,
					func: () => {
						easyrtc.sendDataWS(who, 'confirm-call', admin);
						easyrtc.sendDataWS({ targetRoom: this.currentRoom }, 'microscope-update', this.microscope);
						this.$set(this.areAdmins, who, !!admin);
					}
				});

				this.$notify({
					group: 'test',
					title: 'Join Request',
					text: 'New user wants to join this call'
				});

			}
		},

		onCallAccepted() {
			this.showWaiting = false;
			this.onPageEnter();
		},

		sendMessage() {
			easyrtc.sendDataWS(
				{ targetRoom: this.currentRoom },
				'text-message',
				{ text: this.message }
			);
			this.onTextMessage(this.easyrtcId, { text: this.message });
			this.message = '';

			this.unreadMessages = 0;
		},

		onHangup(index) {
			easyrtc.hangup(this.videos[index].id);
			this.videos.splice(index, 1);
		},

		async onStart(callback) {
			if (!(await this.$validator.validateAll())) {
				return;
			}

			easyrtc.leaveRoom('default');
			easyrtc.setRoomOccupantListener(this.onRoomOccupant);
			easyrtc.joinRoom(this.currentRoom, null, () =>
				this.$nextTick(callback)
			);
			//console.log('joining');
		},

		onViewerEnter() {
			if (easyrtc.getRoomOccupantsAsArray(this.currentRoom).length == 1) {
				alert('This room does not exist.');
				easyrtc.leaveRoom(this.currentRoom);
				return;
			} 

			this.showLogin = false;
			this.showWaiting = true;

			// Send nickname to everyone
			easyrtc.sendDataWS({ targetRoom: this.currentRoom }, 'nickname', {
				nickname: this.username
			});

			// Request permission to enter room
			this.requestAccess();
		},

		onHostEnter() {
			var occ = easyrtc.getRoomOccupantsAsArray(this.currentRoom);
			easyrtc.getRoomList(a => console.log(a));

			if (occ.length === 1) {
				this.showLogin = false;
				this.isHost = true;
				this.connectToMicroscope();

				if (this.showWaiting) {
					easyrtc.sendDataWS(
						{ targetRoom: this.currentRoom },
						'is-host'
					);
				}

				this.onPageEnter();
			} else {
				this.showLogin = false;
				this.showWaiting = true;

				// Send nickname to everyone
				easyrtc.sendDataWS(
					{ targetRoom: this.currentRoom },
					'nickname',
					{ nickname: this.username }
				);

				easyrtc.sendDataWS(
					{ targetRoom: this.currentRoom },
					'join-admin'
				);

				//
				setTimeout(this.onHostDelayedEnter, 5000);
			}
		},

		onHostDelayedEnter() {
			if (Object.keys(this.host).length === 0) {
				this.showLogin = false;
				this.showWaiting = false;
				this.isHost = true;
				this.connectToMicroscope();

				if (this.showWaiting) {
					easyrtc.sendDataWS(
						{ targetRoom: this.currentRoom },
						'is-host'
					);
				}

				this.onPageEnter();
			}
		},

		requestAccess(admin) {
			if (this.showWaiting) {
				easyrtc.sendDataWS(
					{ targetRoom: this.currentRoom },
					'can-call',
					admin
				);
				setTimeout(() => this.requestAccess(admin), 1000);
			}
		},

		onPageEnter() {
			this.onMediaStart();
			this.nicknames[this.easyrtcId] = this.username;
		},

		connectToMicroscope() {
			this.microscopeSocket = new WebSocket('ws://127.0.0.1:9985/ws');
			this.microscopeSocket.onerror=() => alert('Please connect a microscope and refresh the page.');
			this.microscopeSocket.onopen = () => {
				//connected = true;
				//document.getElementById("s1").innerText = "+ Connected.";
				this.microscopeSocket.send('{"A":"Smart Stage Client Web"}');
				//document.getElementById("cn").disabled = !connected;
				//document.getElementById("sm").disabled = !connected;
				// keepAlive(ws);
				this.microscopeSocket.send('mfeatures#');
				this.microscopeSocket.send('mstatus');
				this.microscopeSocket.send('mcommand:L-2  #');
				this.microscopeSocket.send('{"getAutofocus": 0 }');

				// Keep updating microscope at intervals
				setInterval(this.updateMicroscope, 1000);
			};

			//() => { this.microscopeSocket.send('mConnected'); };
			this.microscopeSocket.onmessage = this.onMicroscopeMessage;
		},

		updateMicroscope() {
			if (performance.now() - this.lastMicroscopeMessageRecieved > 1000) {
				this.microscopeSocket.send('mstatus');
			}
			// to be sure microscope intialized, microscope menu shows
			if(!this.microscope.intialized)
				this.microscopeSocket.send('mfeatures#');
		},

		onMicroscopeMessage(event) {
			var data;
			//console.log(event);

			try {
				data = JSON.parse(event.data);
			} catch (e) {
				//console.log('Unknown message: ' + event.data);
				return;
			}

			this.lastMicroscopeMessageRecieved = performance.now();

			if (data.getImage) {
				var canvas = document.createElement('canvas');
				canvas.width = localVideo.videoWidth;
				canvas.height = localVideo.videoHeight;

				var ctx = canvas.getContext('2d');
				ctx.drawImage(localVideo, 0, 0, canvas.width, canvas.height);

				var data = canvas.toDataURL('jpeg');
				data = data.replace(/^data:image\/(png|jpg);base64,/, '');
				this.microscopeSocket.send(
					JSON.stringify({ type: 'image', mimage: data })
				);
			}

			if (data.mfeatures) {
				this.microscope.intialized = true;
				this.microscope.features.x = data.mfeatures.move.X;  //2000
				this.microscope.features.y = data.mfeatures.move.Y;  // 800
				this.microscope.features.z = data.mfeatures.move.Z;  // 5500

				this.microscope.scan = data.mfeatures.scan;   // X [0,1500]  Y [0,700]
				this.microscope.lens.x = 750; //data.mfeatures.lens_center;   // X 550  Y 340, Z 6150
				this.microscope.lens.y = 350; //data.mfeatures.lens_center;
				this.microscope.pSlide = data.mfeatures.slide_phy;  // X 3, Y 1
				this.microscope.pMove = data.mfeatures.move_phy;

				easyrtc.sendDataWS(
					{ targetRoom: this.currentRoom },
					'microscope-update',
					this.microscope
				);
			}

			if (data.status) {		// Is moving or not
				this.microscope.status.x = data.status.X;
				this.microscope.status.y = data.status.Y;
				this.microscope.status.z = data.status.Z;

				easyrtc.sendDataWS(
					{ targetRoom: this.currentRoom },
					'microscope-update',
					this.microscope
				);
			}

			if (data.position) {	// current X, Y, Z position
				this.microscope.position.x = data.position.X;
				this.microscope.position.y = data.position.Y;
				this.microscope.position.z = data.position.Z;

				if (this.currentZ === -1) {
					this.currentZ = data.position.Z;
				}

				easyrtc.sendDataWS(
					{ targetRoom: this.currentRoom },
					'microscope-update',
					this.microscope
				);
			}

			if (data.getObjective) {
				this.microscopeSocket.send({ objective: this.objectiveLens });
			}

			if (data.power === 0) {
				alert('The microscope is not on! Please turn it on.');
			}

			if (data.autofocus) {
				this.microscope.autofocus = !!data.autofocus;

				easyrtc.sendDataWS(
					{ targetRoom: this.currentRoom },
					'microscope-update',
					this.microscope
				);
			}

			if (data.hasOwnProperty("getImageSequence")) {
				if (!data.getImageSequence) {   // clear previous timer
					if (this.imageSequenceTimer) {
						clearInterval(this.imageSequenceTimer);
					}
					this.imageSequenceTimer = 0;

				} else {
					this.WebSocketSendImg(data.getImageSequence);
				}
			}
		},

		moveMicroscopeZ() {
			if (!this.microscope.status.z) {
				this.moveMicroscope(
					'mcommand:  Z,' +
						(this.currentZ - this.microscope.position.z) +
						',5#'
				);
			}
		},

		setLighting(val) {
			this.moveMicroscope(`mcommand:L${val}  #`);
			easyrtc.sendDataWS( { targetRoom: this.currentRoom }, 'lighting', this.lighting);
		},

		updateLens(obj) {
			this.microscopeSocket.send({ objective: this.objectiveLens });
		},

		moveMicroscope(command) {
			if (this.isHost) {
				this.microscopeSocket.send(command);
			}

			if (this.showMicroscopeControls) {
				easyrtc.sendDataWS(
					{ targetRoom: this.currentRoom },
					'microscope-command',
					command
				);
			}
		},

		takeScreenshot() {
			var video = document.getElementById("largeVideo");

			var canvas = document.createElement('canvas');
			canvas.width = 640;
			canvas.height = 480;
			var ctx = canvas.getContext('2d');

			//draw image to canvas. scale to target dimensions
			ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

			//convert to desired file format
			var dataURI = canvas.toDataURL('image/jpeg');
			this.screenshot = dataURI;

			this.$refs.screenshotModal.show();
		},

		saveScreenshot() {
			this.$app.service('images').create({
				userId: this.userId,
				sampleId: this.sampleId,
				sampleName: this.sampleName,
				screenshot: this.screenshot,
				comments: [
					{
						userId: this.userId,
						name: this.username,
						text: this.comments
					}
				]
			});
		},

		sendSample() {
			easyrtc.sendDataWS({ targetRoom: this.currentRoom }, 'sample-details',  { id: this.sampleId, name: this.sampleName });
		},

		WebSocketSendImg(interval = 0) {
	if (!this.microscopeSocket) return;
		var video = document.getElementById("largeVideo");
           // Create an empty canvas element
           var canvas = document.createElement("canvas");
           canvas.width = video.videoWidth; //img.width;
           canvas.height = video.videoHeight; // img.height;

           // Copy the image contents to the canvas
           var ctx = canvas.getContext("2d");

           if (interval) {
               this.imageSequenceTimer = setInterval(() => {
                   if (!video.paused && !video.ended) {
                       ctx.drawImage(video, 0, 0);
                       this.sendImg(canvas);
                   }
               }, interval);
           }
           else {
               ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
               this.sendImg(canvas);
			}
				canvas.parentNode.removeChild(canvas);
		}, 
       sendImg(canvas) {
           // Get the data-URL formatted image
           // Firefox supports PNG and JPEG. You could check img.src to
           // guess the original format, but be aware the using "image/jpg"
           // will re-encode the image.
           var dataURL = canvas.toDataURL("image/jpg", 0.5);

           var data = dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
           data = '{"mimage":"' + data + '"}';
           //console.log(data.length);
           this.microscopeSocket.send(data);
		},
		
		}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#easyrtcErrorDialog {
	display: none !important;
}

.edge-button:hover {
	opacity: 1!important;
}
</style>
